/**
 * Pipe ajoutant conditionnellement un objet vide en 1ere position dans une liste.
 * L'objet est initialisé avec :
 *  - un attribut, dont le nom est paramétrable, réprésentant la valeur, à vide.
 *  - (optionnel) un attribut, dont le nom est paramétrable, représentant le label, à vide.
 */
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	standalone: true,
	name: 'optionVide'
})
export class OptionVidePipe implements PipeTransform {

	transform(items: object[], avecOptionVide = true, attributValeur: string = 'value', attributLabel: string = 'label'): object[] {
		if (avecOptionVide) {
			const optionVide = {};
			optionVide[attributValeur] = null;
			optionVide[attributLabel] = '\xa0';
			return items ? [optionVide, ...items] : [optionVide];
		}
		return items;
	}
}
